import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import UserData from '@/components/UserData'
import OperateData from '@/components/OperateData'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'UserData',
      component: UserData
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/UserData',
      name: 'UserData',
      component: UserData
    },
    {
      path: '/OperateData',
      name: 'OperateData',
      component: OperateData
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js